/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  ADD_CLIENT_CHECKLIST_ANSWER,
  ADD_CLIENT_CHECKLIST_ANSWER_SUCCESS,
  ADD_CLIENT_CHECKLIST_ANSWER_ERROR,
  LOAD_CLIENT_CHECKLIST_ANSWER,
  LOAD_CLIENT_CHECKLIST_ANSWER_SUCCESS,
  LOAD_CLIENT_CHECKLIST_ANSWER_ERROR,
} from "./constants"

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function loadClientChecklistAnswer(id) {
  return {
    type: LOAD_CLIENT_CHECKLIST_ANSWER,
    id,
  }
}

export function loadClientChecklistAnswerSuccess(checklist_answer_details) {
  return {
    type: LOAD_CLIENT_CHECKLIST_ANSWER_SUCCESS,
    checklist_answer_details,
  }
}

/**
 * @param {string} error
 */

export function loadClientChecklistAnswerError(error) {
  return {
    type: LOAD_CLIENT_CHECKLIST_ANSWER_ERROR,
    error,
  }
}

export function addClientChecklistAnswer(checklistAnswer) {
  console.log("record", checklistAnswer)
  return {
    type: ADD_CLIENT_CHECKLIST_ANSWER,
    checklistAnswer,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function addClientChecklistAnswerSuccess(checklistAnswer, success) {
  console.log("record", checklistAnswer)
  return {
    type: ADD_CLIENT_CHECKLIST_ANSWER_SUCCESS,
    checklistAnswer,
    success,
  }
}

/**
 * @param {string} error
 */
export function addClientChecklistAnswerError(error) {
  return {
    type: ADD_CLIENT_CHECKLIST_ANSWER_ERROR,
    error,
  }
}

const actions = {
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  addClientChecklistAnswer,
  addClientChecklistAnswerError,
  addClientChecklistAnswerSuccess,

  loadClientChecklistAnswer,
  loadClientChecklistAnswerSuccess,
  loadClientChecklistAnswerError,
}

export default actions
